function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { ErrorMessage } from "../input/Input.styles";
import moment from 'moment';
import React, { Component } from 'react';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/initialize';
import { renderErrors } from "../../utils";
import { hasError } from "../../utils/hasError/hasError";
import { DatePickerWrapper, DesktopDatePicker, IconCalendar, IconChevron, MobileDatePicker, NativeInput, NavNext, NavPrev, PrefixIcon, PrefixText } from "./Datepicker.styles";
export var DatePicker =
/*#__PURE__*/
function (_Component) {
  _inherits(DatePicker, _Component);

  function DatePicker() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DatePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DatePicker)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      open: false
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "dateToOutput", function (date) {
      if (_this.props.useNativeDate && moment.isMoment(date)) {
        return date.toDate();
      }

      return date;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "dateToMoment", function (date) {
      if (date && !moment.isMoment(date)) {
        return moment(date);
      }

      return date;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onNativeInputChange", function (event) {
      var date = event.currentTarget.value;

      if (!date) {
        _this.onDateChange(null);
      } else {
        var momentDate = moment(date); // react-dates uses 12 hours, matching

        momentDate.hour(12);

        _this.onDateChange(momentDate);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "makeIsOutsideRange", function () {
      var maxDate = _this.props.maxDate && _this.dateToMoment(_this.props.maxDate);

      var minDate = _this.props.minDate && _this.dateToMoment(_this.props.minDate);

      return function (date) {
        if (date) {
          var momentDate = _this.dateToMoment(date);

          if (maxDate && maxDate.isBefore(momentDate)) {
            return true;
          }

          if (minDate && minDate.isAfter(momentDate)) {
            return true;
          }
        }

        return false;
      };
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onDateChange", function (date) {
      if (date && _this.makeIsOutsideRange()(date)) {
        return;
      }

      _this.props.onDateChange(_this.dateToOutput(date));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onFocusChange", function () {
      _this.setState(function (state) {
        return {
          open: !state.open
        };
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "hasError", function () {
      return hasError(_this.props.meta, _this.props.disabled);
    });

    return _this;
  }

  _createClass(DatePicker, [{
    key: "render",
    value: function render() {
      var momentDate = this.props.date && this.dateToMoment(this.props.date);
      var maxDate = this.props.maxDate && this.dateToMoment(this.props.maxDate);
      var minDate = this.props.minDate && this.dateToMoment(this.props.minDate);
      var isOutsideRange = this.makeIsOutsideRange();
      var icon = this.props.icon ? React.isValidElement(this.props.icon) ? this.props.icon : React.createElement(this.props.icon) : undefined;
      return React.createElement(DatePickerWrapper, null, !!this.props.text && React.createElement(PrefixText, null, this.props.text), !!icon && React.createElement(PrefixIcon, null, icon), React.createElement(MobileDatePicker, null, React.createElement(NativeInput, {
        hasError: this.hasError(),
        "data-testid": "date-picker__mobile",
        max: maxDate ? maxDate.format('YYYY-MM-DD') : '',
        min: minDate ? minDate.format('YYYY-MM-DD') : '',
        value: momentDate ? momentDate.format('YYYY-MM-DD') : '',
        type: "date",
        onChange: this.onNativeInputChange,
        disabled: this.props.disabled
      }), this.hasError() && React.createElement(ErrorMessage, null, this.props.meta.error || this.props.meta.submitError)), React.createElement(DesktopDatePicker, {
        "data-testid": "date-picker__wrapper",
        hasError: this.hasError()
      }, React.createElement(SingleDatePicker, {
        verticalSpacing: 0,
        daySize: 38,
        navPrev: React.createElement(NavPrev, null, React.createElement(IconChevron, null)),
        navNext: React.createElement(NavNext, null, React.createElement(IconChevron, null)),
        noBorder: true,
        disabled: this.props.disabled,
        displayFormat: this.props.displayFormat,
        isOutsideRange: isOutsideRange,
        hideKeyboardShortcutsPanel: true,
        readOnly: true,
        id: this.props.id,
        date: momentDate,
        focused: this.state.open,
        placeholder: this.props.placeholder,
        onDateChange: this.onDateChange,
        onFocusChange: this.onFocusChange,
        numberOfMonths: 1
      }), this.hasError() && React.createElement(ErrorMessage, {
        className: "datepicker__error"
      }, renderErrors(this.props.meta.error, this.props.meta.submitError))));
    }
  }]);

  return DatePicker;
}(Component);

_defineProperty(DatePicker, "defaultProps", {
  displayFormat: 'DD.MM.YYYY',
  icon: IconCalendar,
  placeholder: '',
  useNativeDate: true
});